import type { FC } from 'react';
import React from 'react';
import { Background } from '@alfa-bank/site-background';

import { useBackgroundByMedia } from '../utils/use-background-by-media';
import type { IResponsiveBgProps } from '../models';

/**
 * Чтобы не создавалась новая ссылка на onChange, если onChange не передали.
 */
const noop = () => {};

export const ResponsiveBackground: FC<IResponsiveBgProps> = ({
    className,
    onChange = noop,
    sources,
    ...props
}) => {
    const { background } = useBackgroundByMedia(sources, onChange);

    return <Background {...props} className={className} image={background?.src} />;
};
